
export const legal = {
  avisoLegal: {
    title: 'Aviso Legal',
    lastUpdate: 'Última actualización: 10 de enero de 2025',
    section1: {
      title: '1. Condiciones generales',
      content: 'El acceso y uso de este sitio web atribuye la condición de usuario y supone la aceptación plena de las presentes condiciones generales. Si no está de acuerdo con estas condiciones, le rogamos que no utilice este sitio web.'
    },
    section2: {
      title: '2. Titular del sitio',
      denomination: 'VELXIA (nombre comercial)',
      phone: '694 220 264',
      email: 'info@velxia.es',
      fiscalNote: 'Para datos fiscales completos y NIF, pueden solicitarse en info@velxia.es.'
    },
    section3: {
      title: '3. Objeto',
      content: 'VELXIA ofrece servicios de automatización e inteligencia artificial para negocios de servicios, incluyendo asistentes virtuales para WhatsApp, automatizaciones de procesos, integraciones con sistemas existentes y desarrollo de sitios web optimizados.'
    },
    section4: {
      title: '4. Propiedad intelectual e industrial',
      content: 'Todos los contenidos de este sitio web (textos, imágenes, diseños, logotipos, código fuente, etc.) son propiedad de VELXIA o de terceros que han autorizado su uso. Queda prohibida su reproducción, distribución o modificación sin autorización expresa. La marca VELXIA se encuentra actualmente en proceso de registro.'
    },
    section5: {
      title: '5. Acceso',
      content: 'El acceso al sitio web es gratuito. VELXIA se reserva el derecho de modificar, suspender o interrumpir, temporal o permanentemente, el acceso al sitio web sin necesidad de previo aviso.'
    },
    section6: {
      title: '6. Responsabilidades y obligaciones',
      content: 'El usuario se compromete a hacer un uso lícito y adecuado del sitio web, absteniéndose de realizar actividades ilícitas o que puedan dañar los derechos e intereses de terceros. VELXIA no se responsabiliza de los daños derivados del uso indebido del sitio web por parte de los usuarios, ni de fallos técnicos, interrupciones o errores en el servicio.'
    },
    section7: {
      title: '7. Duración y modificaciones',
      content: 'VELXIA se reserva el derecho de modificar unilateralmente, en cualquier momento y sin previo aviso, las presentes condiciones generales. Los cambios serán efectivos desde su publicación en el sitio web.'
    },
    section8: {
      title: '8. Legislación aplicable y fuero',
      content: 'Las presentes condiciones se rigen por la legislación española. Para cualquier controversia derivada del uso de este sitio web, las partes se someten a los juzgados y tribunales que correspondan conforme a derecho.'
    }
  },
  privacy: {
    title: 'Política de Privacidad',
    lastUpdate: 'Última actualización: 10 de enero de 2025',
    section1: {
      title: '1. Responsable del tratamiento',
      responsible: 'VELXIA (nombre comercial)',
      email: 'info@velxia.es',
      phone: '694 220 264'
    },
    section2: {
      title: '2. Finalidades, bases jurídicas y conservación',
      intro: 'Tratamos tus datos personales para las siguientes finalidades:',
      item1: {
        title: 'a) Gestionar solicitudes',
        content: 'Atender y responder a tus consultas recibidas por formulario, email, teléfono o WhatsApp.',
        base: 'Base jurídica: medidas precontractuales o interés legítimo.',
        conservation: 'Conservación: 12 meses desde la última interacción si no se establece relación contractual.'
      },
      item2: {
        title: 'b) Comunicaciones comerciales',
        content: 'Enviarte información sobre nuestros servicios, novedades y promociones.',
        base: 'Base jurídica: consentimiento expreso.',
        conservation: 'Conservación: hasta que retires tu consentimiento.'
      },
      item3: {
        title: 'c) Analítica y mejora del sitio',
        content: 'Analizar el uso del sitio web para mejorar la experiencia de usuario.',
        base: 'Base jurídica: consentimiento (cookies).',
        conservation: 'Conservación: según la política de cookies.'
      },
      item4: {
        title: 'd) Seguridad',
        content: 'Mantener registros de acceso (logs) para garantizar la seguridad del sitio.',
        base: 'Base jurídica: interés legítimo.',
        conservation: 'Conservación: hasta 24 meses, salvo obligación legal.'
      }
    },
    section3: {
      title: '3. Categorías de datos',
      intro: 'Podemos recoger las siguientes categorías de datos personales:',
      item1: 'Datos de identificación: nombre y apellidos.',
      item2: 'Datos de contacto: correo electrónico, teléfono.',
      item3: 'Datos de navegación: dirección IP, tipo de navegador, páginas visitadas.',
      item4: 'Datos proporcionados voluntariamente: información incluida en formularios o comunicaciones.'
    },
    section4: {
      title: '4. Destinatarios y encargados del tratamiento',
      content: 'No cedemos tus datos a terceros, salvo obligación legal. Podemos utilizar proveedores de servicios (hosting, email, CRM) que actúan como encargados del tratamiento y están obligados contractualmente a cumplir con el RGPD y garantizar la seguridad de tus datos.'
    },
    section5: {
      title: '5. Derechos del usuario',
      intro: 'Tienes derecho a:',
      item1: 'Acceso: conocer qué datos tratamos sobre ti.',
      item2: 'Rectificación: corregir datos inexactos o incompletos.',
      item3: 'Supresión: solicitar la eliminación de tus datos cuando ya no sean necesarios.',
      item4: 'Oposición: oponerte al tratamiento de tus datos.',
      item5: 'Limitación: solicitar la limitación del tratamiento.',
      item6: 'Portabilidad: recibir tus datos en formato estructurado.',
      item7: 'Retirada del consentimiento: en cualquier momento, sin efectos retroactivos.',
      contact: 'Puedes ejercer estos derechos enviando un correo a info@velxia.es. También tienes derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es).'
    },
    section6: {
      title: '6. Menores de edad',
      content: 'Este sitio web no está dirigido a menores de 14 años. No tratamos conscientemente datos de menores sin el consentimiento de sus padres o tutores legales.'
    },
    section7: {
      title: '7. Procedencia de los datos y decisiones automatizadas',
      content: 'Los datos personales que tratamos proceden directamente de ti (formularios, emails, llamadas, WhatsApp). No tomamos decisiones automatizadas que produzcan efectos jurídicos sobre ti o te afecten significativamente.'
    },
    section8: {
      title: '8. Cláusula informativa para formularios',
      content: 'Responsable: VELXIA. Finalidad: gestionar tu solicitud y responderte. Base jurídica: medidas precontractuales/interés legítimo. Puedes ejercer tus derechos en info@velxia.es. Más información en nuestra Política de Privacidad.'
    },
    section9: {
      title: '9. WhatsApp y otros servicios de terceros',
      content: 'Si nos contactas a través de WhatsApp u otros servicios de mensajería, ten en cuenta que estos son servicios de terceros con sus propias políticas de privacidad. Dichos servicios pueden realizar transferencias internacionales de datos. Te recomendamos consultar sus políticas antes de utilizarlos.'
    }
  },
  cookies: {
    title: 'Política de Cookies',
    lastUpdate: 'Última actualización: 10 de enero de 2025',
    section1: {
      title: '1. ¿Qué son las cookies?',
      content: 'Una cookie es un fichero que se descarga en tu ordenador al acceder a determinadas páginas web. Las cookies permiten a una página web, entre otras cosas, almacenar y recuperar información sobre los hábitos de navegación de un usuario o de su equipo y, dependiendo de la información que contengan y de la forma en que utilice su equipo, pueden utilizarse para reconocer al usuario.'
    },
    section2: {
      title: '2. Cookies utilizadas en este sitio web',
      intro: 'Este sitio web utiliza únicamente cookies técnicas y funcionales necesarias para su correcto funcionamiento:',
      technical: {
        title: 'Cookies técnicas y de sesión',
        content: 'Permiten al usuario la navegación a través del sitio web y la utilización de las diferentes opciones o servicios que en ella existen. Son estrictamente necesarias para la prestación del servicio.'
      },
      functional: {
        title: 'Cookies funcionales',
        content: 'Permiten recordar información para que el usuario acceda al servicio con determinadas características (por ejemplo, el idioma seleccionado). No se utilizan cookies de análisis, publicidad o terceros en este sitio web.'
      }
    },
    section3: {
      title: '3. Finalidad de las cookies',
      intro: 'Las cookies que utilizamos tienen las siguientes finalidades:',
      item1: 'Permitir la navegación y uso del sitio web.',
      item2: 'Recordar tus preferencias de idioma.',
      item3: 'Mantener tu sesión activa durante tu visita.'
    },
    section4: {
      title: '4. Cómo desactivar o eliminar las cookies',
      intro: 'Puedes permitir, bloquear o eliminar las cookies instaladas en tu equipo mediante la configuración de las opciones del navegador instalado en tu ordenador. A continuación te facilitamos enlaces a las principales guías de configuración:'
    },
    section5: {
      title: '5. Actualización de la política de cookies',
      content: 'VELXIA puede modificar esta Política de Cookies en función de exigencias legislativas, reglamentarias, o con la finalidad de adaptar dicha política a las instrucciones dictadas por la Agencia Española de Protección de Datos, por ello se aconseja a los usuarios que la visiten periódicamente.'
    },
    section6: {
      title: '6. Más información',
      content: 'Si tienes dudas sobre esta Política de Cookies, puedes contactar con VELXIA en'
    }
  }
};
